@use "src/theme";

.root {
  display: grid;
  min-height: 0;
  grid-template-rows: min-content minmax(0, 1fr) min-content;
  overflow: hidden;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  background: var(--color-card);
  box-shadow: var(--shadow-xs);
}

.header {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 1rem 1rem 0.75rem;
}

.title {
  color: var(--color-muted-foreground);
}

.list {
  display: grid;
  gap: 0.25rem;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  padding: 0.125rem 0.625rem 0.75rem;
  hyphens: auto;
}

.item {
  margin: 0;
  scroll-margin-block: 1.5rem;
}

.link {
  position: relative;
  display: block;
  min-height: 2.375rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  color: var(--color-muted);
  font-size: 0.78rem;
  font-weight: 500;
  line-height: 1.4;
  text-wrap: pretty;
  transition:
    color 140ms ease,
    background 140ms ease,
    border-color 140ms ease;
}

.link:hover {
  background: var(--color-card-hover);
  color: var(--color-foreground);
}

.link:focus-visible {
  @include theme.focus-ring-inset;
}

.link[data-active="true"] {
  @include theme.nav-item-active;
}

.depth3 {
  margin-inline-start: 0.75rem;
}

.depth4 {
  margin-inline-start: 1.5rem;
}

.depth5 {
  margin-inline-start: 2.25rem;
}

.depth6 {
  margin-inline-start: 3rem;
}

.footer {
  display: grid;
  gap: 0.25rem;
  margin: 0 0.625rem;
  padding: 0.75rem 0;
  border-top: 1px solid var(--color-border);
}

.backToTop {
  display: flex;
  width: 100%;
  min-height: 2.375rem;
  align-items: center;
  gap: 0.625rem;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-md);
  color: var(--color-muted);
  font-size: 0.78rem;
  font-weight: 500;
  text-align: start;
  transition:
    color 140ms ease,
    background 140ms ease;
}

.backToTop:hover {
  background: var(--color-card-hover);
  color: var(--color-foreground);
}

.backToTop:focus-visible {
  @include theme.focus-ring-inset;
}

.compact {
  display: none;
}

@media (max-width: 1199px) {
  .compact {
    display: block;
    margin-bottom: 1.5rem;
  }
  .compact .compactTrigger {
    cursor: pointer;
    padding: 0.875rem 1rem;
    font-weight: 600;
    color: var(--color-foreground);
  }
  .compact .list {
    max-height: 45dvh;
  }
}
